/**
 * Interface padrão
 */
export interface ILocation {
    name: string
    cmn_location_type?: string
    city?: string
    sys_id: string
}
/**
 * Interface padrão paginada
 */
export interface ILocationPaginate {
    sys_id: string
    name: string
    active_sectors: number
    inactive_sectors: number
}
/**
 * Interface para resultados vindos da tabela ServiceNow location_x_sector
 * /api/now/table/x_rdsls_notificabe_m2m_location_x_sector
 */
export interface ILocationSector {
    x_rdsls_notificabe_locations: ILocationSectorRegistryAttr
    x_rdsls_notificabe_sectors?: ILocationSectorRegistryAttr
    u_active: ILocationSectorRegistryAttr
    location_managers?: any[]
    isLoading?: boolean
}
/**
 * Interface de valores dos atributos de ILocationSector
 */
export interface ILocationSectorRegistryAttr {
    display_value: string
    value: string
}
/**
 * Interface para redux action
 */
export interface ILocationAction {
    type: string
    payload: any
}
/**
 * Interface para objeto reducer
 */
export interface ILocationReducer {
    locationSector?: LocationSector
    locationSectorList?: LocationSectorList
    locationSectorListWithManagers?: LocationSectorList
    locationSectorListDataTable: any[][]
    locationsList: LocationList
    location: Location
    locationsListPaginate: LocationListPaginate
    locationCount: string
    locationWithNotificationCount: number
    locationsListNames: string[]
    loading: boolean
    locationCountLoading: boolean
    error: boolean
    lastReturnUpdateLocationSector?: ReturnUpdateLocationSector
}
/**
 * Interface para redux action
 */
export interface ILocationSectorStatusVariables {
    u_sector: string
    u_inactive_locations?: string
    u_active_locations?: string
}
/**
 * Interface para redux action
 */
export interface ILocationSectorStatus {
    sysparm_quantity: number
    variables?: ILocationSectorStatusVariables
}
/**
 * Interface usada no Axios para retorno lista com todas as locations
 */
export interface IResultLocationGetAll {
    result: LocationList
}
/**
 * Interface usada no Axios para retorno lista com as locations com notifications
 */
export interface IResultLocationGetWithNotification {
    result: LocationCountList
}
/**
 * Interface usada no Axios para retorno location/sector por setor id
 */
export interface IResultLocationGetBySectorId {
    result: LocationSectorList
}
/**
 * Interface usada no Axios para retorno lista de setores paginado
 */
export interface IResultLocationGetAllPaginate {
    result: ILocationPaginate
    stats: any
}
/**
 * Tipo para redux action
 */
export type LocationAction = ILocationAction
/**
 * Tipo para lista padrão
 */
export type LocationList = ILocation[]
/**
 * Tipo para lista padrão
 */
export type LocationListPaginate = ILocationPaginate[]
/**
 * Tipo para lista genérica
 */
export type LocationCountList = any[]
/**
 * Tipo para reducer
 */
export type LocationReducer = ILocationReducer
/**
 * Tipo location para listagens
 */
export type Location = ILocation
/**
 * Tipo para tabela ServiceNow: x_rdsls_notificabe_m2m_location_x_sector
 */
export type LocationSector = ILocationSector
/**
 * Tipo para lista padrão
 */
export type LocationSectorList = ILocationSector[]
/**
 * Tipo para realizar update de status ativo e inativo entre setor e unidade
 */
export type LocationSectorStatus = ILocationSectorStatus
/**
 * Tipo para realizar update de status ativo e inativo entre setor e unidade
 */
export type LocationSectorStatusVariables = ILocationSectorStatusVariables
/**
 * Tipo usado no Axios para retorno lista de location paginado
 */
export type ResultLocationGetAllPaginate = IResultLocationGetAllPaginate

/**
 * Objeto para inicializar um objeto LocationSector
 */
export const LocationSectorTypeInitiator: LocationSector = {
    x_rdsls_notificabe_locations: <ILocationSectorRegistryAttr>{
        display_value: 'xxxxxxxxxxxxxxxxxxx',
        value: 'zzzzzzzzzzzzzzzzzz'
    },
    x_rdsls_notificabe_sectors: <ILocationSectorRegistryAttr>{
        display_value: 'xxxxxxxxxxxxxxxxxxx',
        value: 'zzzzzzzzzzzzzzzzzz'
    },
    u_active: <ILocationSectorRegistryAttr>{
        display_value: 'Verdadeiro',
        value: 'true'
    },
    location_managers: [],
    isLoading: false
}
/**
 * Objeto padrão
 */
export const LocationReducerTypeInitiator: ILocationReducer = {
    locationSector: LocationSectorTypeInitiator,
    locationSectorList: <LocationSectorList>[],
    locationSectorListDataTable: [],
    locationsListNames: [],
    locationCount: '0',
    locationWithNotificationCount: 0,
    locationCountLoading: false,
    locationsList: <LocationList>[],
    locationsListPaginate: <LocationListPaginate>[],
    location: null,
    loading: true,
    error: false
}

/**
 * Objeto para inicializar um objeto LocationSector
 */
export const LocationSectorStatusTypeInitiator: LocationSectorStatus = {
    sysparm_quantity: 1,
    variables: <ILocationSectorStatusVariables>{}
}

export type ResultLocationGetAll = IResultLocationGetAll

export type ResultLocationGetWithNotification =
    IResultLocationGetWithNotification
/**
 * Tipo usado no Axios para retorno location/sector por setor id
 */
export type ResultLocationGetBySectorId = IResultLocationGetBySectorId

export interface IReturnUpdateLocationSector {
    sys_id: string
    number: string
    record: string
    redirect_portal_url: string
    redirect_url: string
    table: string
    redirect_to: string
}

export type ReturnUpdateLocationSector = IReturnUpdateLocationSector

export const ReturnUpdateLocationSectorTypeInitiator: ReturnUpdateLocationSector =
    {
        sys_id: '',
        number: '',
        record: '',
        redirect_portal_url: '',
        redirect_url: '',
        table: '',
        redirect_to: ''
    }

export interface IResultUpdateLocationSector {
    result: ReturnUpdateLocationSector
}

export type ResultUpdateLocationSector = IResultUpdateLocationSector

/**
 * Objeto para inicializar um objeto LocationSector
 */
export const ResultUpdateLocationSectorTypeInitiator: ResultUpdateLocationSector =
    {
        result: ReturnUpdateLocationSectorTypeInitiator
    }
